import type { PermissionKey } from '../api/schemas';

/**
 * Where a teammate lands when their profile has the agenda turned off: the
 * first place their profile opens, in the order a counter shift uses them.
 */
const LANDINGS = [
  { to: '/cobrar', key: 'cobrar' },
  { to: '/clientes', key: 'clientes' },
  // Before the list of payments: an accountant opens on the numbers.
  { to: '/finanzas', key: 'finanzas' },
  { to: '/pagos', key: 'pagos' },
  { to: '/facturas', key: 'facturas' },
  { to: '/servicios', key: 'servicios' },
  { to: '/equipo', key: 'horario' },
  { to: '/negocio', key: 'negocio' },
] as const satisfies readonly { to: string; key: PermissionKey }[];

export type TeamLanding = (typeof LANDINGS)[number]['to'];

export function firstPermittedLanding(can: (key: PermissionKey) => boolean): TeamLanding | undefined {
  return LANDINGS.find((landing) => can(landing.key))?.to;
}
